import PropTypes from "prop-types"
import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

import { setThumbnailLoading } from "areas/product/store/actions"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import { isTestMode } from "helpers/application"
import { getImgSrcSet } from "helpers/image"
import { cn } from "styles/utils"

import ProductImagePreview from "./product-image-preview"

const getThumbnailSrcSet = (previewImage) =>
  previewImage.raw_src
    ? getImgSrcSet(previewImage.raw_src, 240, {
        dim_key: "dim",
        sizes: [94, 188],
      })
    : previewImage.srcSet

const PreviewThumbnail = ({ previewImage }) => {
  const dispatch = useDispatch()

  const wizardLoading = useSelector((state) => state.wizard.loading)
  const thumbnailLoading = useSelector(
    (state) => state.previewImageUI.thumbnailLoading
  )
  const isLoadingPreview = !!wizardLoading || thumbnailLoading

  const handleImageLoading = useCallback(() => {
    dispatch(setThumbnailLoading(false))
  }, [dispatch])

  const handlePreviewClick = useCallback(() => {
    try {
      if (!isTestMode) {
        dataLayer.push({
          event: "clicked-enlarge-preview-button",
        })
      }
    } catch (e) {
      console.log("Error sending clicked-enlarge-preview-button event", e)
    }

    openModal("#preview")
  }, [])

  return (
    <Button
      className={cn(
        "border-grey-10 w-94 min-w-94 relative h-80 shrink-0 overflow-hidden border-r",
        (wizardLoading || thumbnailLoading) && "bg-white opacity-50"
      )}
      onClick={handlePreviewClick}
    >
      <ProductImagePreview
        height="240"
        isLoadingPreview={isLoadingPreview}
        loaderClassName="size-12"
        setIsLoadingPreview={handleImageLoading}
        sizes="94px"
        src={previewImage.src}
        srcSet={getThumbnailSrcSet(previewImage)}
        width="240"
      />
      <span className="text-10 absolute bottom-0 left-0 w-full whitespace-nowrap py-4 text-center text-black">
        Click to enlarge
      </span>
    </Button>
  )
}

PreviewThumbnail.propTypes = {
  previewImage: PropTypes.object,
}

export default PreviewThumbnail
